import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { wosIndexOptions } from '@/module/Nomen/WosIndex/model/WosIndexModel';

import { AsyncMultiSelectControl, AsyncSelectControlProps } from '@/core/components';

type WosIndexMultiSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function WosIndexMultiSelectControl<T extends FieldValues>(props: WosIndexMultiSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(wosIndexOptions.getAll());

  return (
    <AsyncMultiSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
